import { FC, useState } from "react";
import { t } from "i18next";

import { useAppSelector } from "../../../../hook/useAppSelector";
import { useAppDispatch } from "../../../../hook/useAppDispatch";

import { setSelectedRowDensity } from "../../../../store/slice/config/config";

import { RowDensity } from "../../../../enum/RowDensity";

import rowDensityIcon from "../../../../assets/img/png/health-monitor/row-density-icon-orange.png";

const RowDensityMenuMobile: FC = () => {
  const dispatch = useAppDispatch();
  const [open, setOpen] = useState(false);
  const selectedRowDensity = useAppSelector(
    (state) => state.configSlice.selectedRowDensity
  );

  const options = [
    { value: RowDensity.NORMAL, label: "Normal" },
    { value: RowDensity.SMALL, label: "Small" },
    { value: RowDensity.EXTRA_SMALL, label: "X-Small" },
  ];

  return (
    <div onClick={() => setOpen(!open)} className="row_density">
      <img src={rowDensityIcon} alt="rowDensityDropdown"></img>
      <span>{t("healthMonitor.footer.pagination.rowDensity")}</span>

      {open && (
        <ul>
          {options.map((option) => (
            <li
              key={option.value}
              onClick={() => {
                dispatch(setSelectedRowDensity(+option.value));
                setOpen(false);
              }}
              style={{
                backgroundColor:
                  selectedRowDensity === option.value ? "#cccccc" : "white",
              }}
            >
              {option.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default RowDensityMenuMobile;
